import React, {Component} from 'react';
import './EditButton.css';

class EditButton extends Component {
	render() {
		return (
			<button className="EditButton" style={this.props.style} onClick={this.props.onClick}>
				<span className={`icon ${this.props.icon || 'icon-mode_edit'}`} />
			</button>
		);
	}
}

export default EditButton;



// WEBPACK FOOTER //
// ./src/widgets/EditButton.js